import { Activity01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Activity = /* @__PURE__ */ createIcon(Activity01Icon, 'Activity');
